export default function putRoleReducer
  (state = { error:'', success:'', processing:false}, action)
{
  switch (action.type) {
    case 'PUT_ROLE_SUCCESS':
      return {...state, ...{success: action.success}};

    case 'PUT_ROLE_ERROR':
      return {...state, ...{error: action.error}};

    case 'PUT_ROLE_PROCESSING':
      return {...state, ...{processing: action.processing}};

    default: return state;
  }
}